

// export enum BatchItemType {
//   Manual,
//   Automated,
//   Relisting
// }

import { BatchItemType } from "../../../models/bulkListings/BulkListing";


export default function RecentlyListedTypeCell({ type }: { type: BatchItemType }) {
  var className = "rounded-full px-3 py-1 text-xs font-semibold ";
  switch (type) {
    case BatchItemType.Manual:
      className += "bg-green-100 text-green-800";
      break;
    case BatchItemType.Automated:
      className += "bg-blue-100 text-blue-600";
      break;
    case BatchItemType.Relisted:
      className += "bg-purple-100 text-purple-600";
      break;
  }

  return <div className="flex justify-center items-center flex-1 text-nowrap">
    <span>
      <span className={className}>{BatchItemType[type]}</span>
    </span>
  </div>
};